import css from 'styled-jsx/css';

const staticStyles = css`
  @import 'src/common/styling/_mixins-scss/screen-size';

  .UserPartnerAccountCreateForm {
    max-width: 100%;
    min-width: 0;
    overflow: visible;
    padding-right: 8px;

    .UserPartnerAccountCreateForm__inputs-inner {
      display: block;
    }

    .UserPartnerAccountCreateForm__field {
      display: grid;
      grid-template-columns: 280px 1fr;
      gap: 18px;
      align-items: start;
      margin-bottom: 16px;
    }

    .UserPartnerAccountCreateForm__field-label {
      display: block;
      margin: 0;
      padding-top: 17px;
      color: #5f636d;
      font-size: 15px;
      font-weight: 600;
      line-height: 1.3;
      text-align: left;
    }

    .UserPartnerAccountCreateForm__field-control {
      min-width: 0;
    }

    .UserPartnerAccountCreateForm__field-label span {
      margin-right: 4px;
      color: #f05b63;
    }

    @include respond-to(sm) {
      max-width: 100%;
      min-width: 100%;

      .UserPartnerAccountCreateForm__field {
        display: block;
      }

      .UserPartnerAccountCreateForm__field-label {
        margin-bottom: 6px;
        padding-top: 0;
      }
    }

    .UserPartnerAccountCreateForm__distribution {
      margin-top: 20px;
      padding-top: 0;
    }

    :global(.SelectLinkDistributionModal__table-wrapper) {
      max-height: 330px;
      overflow-x: auto;
      overflow-y: auto;
    }

    :global(.SelectLinkDistributionModal__pagination) {
      padding-top: 10px;
      padding-bottom: 10px;
    }

    .UserPartnerAccountCreateForm__distribution h3 {
      margin: 0 0 16px;
      border-left: 4px solid #3d9de8;
      color: #343a40;
      font-size: 18px;
      font-weight: 600;
      line-height: 24px;
      padding-left: 10px;
    }

    .UserPartnerAccountCreateForm__selected {
      margin-top: 12px;
      color: #6d737d;
      font-size: 14px;
    }

    .UserPartnerAccountCreateForm__contract-warning {
      margin-top: 12px;
      color: #f05b63;
      font-size: 14px;
      line-height: 1.4;
    }

    .UserPartnerAccountCreateForm__selected strong {
      color: #3d9de8;
      font-size: 18px;
    }

    .UserPartnerAccountCreateForm__footer {
      display: flex;
      justify-content: flex-end;
      gap: 12px;
      margin-top: 20px;
    }

    .UserPartnerAccountCreateForm__footer :global(.DefaultButton) {
      margin-top: 10px;
    }

    .UserPartnerAccountCreateForm__footer :global(.DefaultButton.filled:not(:disabled)) {
      border-color: transparent;
      background: linear-gradient(90deg, #1ea8ed 0%, #25ddbe 100%);
      box-shadow: 0 4px 10px rgba(30, 168, 237, 0.28);
    }

    .UserPartnerAccountCreateForm__footer :global(.DefaultButton.filled:not(:disabled)):hover {
      background: linear-gradient(90deg, #149be0 0%, #18ceb0 100%);
      box-shadow: 0 5px 12px rgba(30, 168, 237, 0.36);
    }

    .UserPartnerAccountCreateForm__footer :global(.DefaultButton.filled:disabled) {
      border-color: transparent;
      background: #c8d1dc;
      box-shadow: none;
    }
  }
`;

export { staticStyles };
